import CardPaymentMethodEditorViewModel from 'billing/payment-methods/CardPaymentMethodEditorViewModel'
import PaymentMethodsRootViewModel from 'billing/payment-methods/PaymentMethodsRootViewModel'
import Button from 'components/Button'
import ContentError from 'components/ContentError'
import ContentLoading from 'components/ContentLoading'
import ErrorBlock from 'components/ErrorBlock'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import { observer } from 'mobx-react'
import * as React from 'react'
import CardPaymentMethodEditorContent from './CardPaymentMethodEditorContent'

interface AddPaymentMethodModalProps {
  vm: PaymentMethodsRootViewModel
}

export default observer(function AddPaymentMethodModal({
  vm,
}: AddPaymentMethodModalProps) {
  const modal = vm.newPaymentMethodEditorModal
  if (!modal) {
    return null
  }

  const editor = modal.editor
  const disabled = editor.save.pending || editor.prepare.pending
  return (
    <ModalSheet
      showing={modal.showing}
      onRequestClose={modal.close}
      disableCloseOnOutsideClick={disabled}
      disableCloseOnEsc={disabled}
    >
      <>
        <ModalSheetHeader withCloseButton />
        <ModalSheetContent>
          {editor.prepare.match({
            pending: () => <ContentLoading />,
            rejected: (err: unknown) => (
              <ModalSheetContentBlock>
                <ContentError error={err} />
              </ModalSheetContentBlock>
            ),
            resolved: () => (
              <>
                {editor instanceof CardPaymentMethodEditorViewModel && (
                  <CardPaymentMethodEditorContent vm={editor} />
                )}
              </>
            ),
          })}
        </ModalSheetContent>
        {editor.save.error && (
          <ErrorBlock
            tackOn="bottom"
            error={editor.save.error}
            onCloseClick={editor.save.reset}
          />
        )}

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button onClick={modal.close} disabled={disabled}>
              Cancel
            </Button>
            <Button
              type="primary"
              disabled={disabled}
              loading={editor.save.pending}
              onClick={editor.save}
              dataTest="add-payment-method-modal-save-button"
            >
              Save
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </>
    </ModalSheet>
  )
})
